module.exports = __webpack_public_path__ + "img/campaign.27d81b88.svg";